import * as React from 'react';

function SvgCalendar(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 34" {...props}>
      <g stroke="#0C3998" strokeWidth={2}>
        <path d="M29.444 6.333H4.556A3.556 3.556 0 0 0 1 9.889v19.555A3.556 3.556 0 0 0 4.556 33h24.888A3.556 3.556 0 0 0 33 29.444V9.89a3.556 3.556 0 0 0-3.556-3.556Z" />
        <path
          strokeLinecap="round"
          d="M1 15.222h32M9.889 1v7.111M24.11 1v7.111M23.13 20.692h3.716m-19.692 0h3.715m4.46 0h3.715M23.13 26.846h3.716m-19.692 0h3.715m4.46 0h3.715"
        />
      </g>
    </svg>
  );
}
export default SvgCalendar;
